// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__-L8VN","outline":"Button_outline__ALDXu","colored":"Button_colored__-y2Yy","disabled":"Button_disabled__rbX6W"};